import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllContest } from "../../redux/services/contestSlice";
import { convertUtcToIst } from "../../common/TimeUtils";
import moment from "moment-timezone";
import Table from "../../common/Table";
import { exportToTablePDF } from "../../common/PdfFormat";

const Contest = () => {
  const dispatch = useDispatch();
  const getContestData = useSelector((state) => state?.contest?.contestData);
  const [page, setPage] = useState(0);
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [filter, setFilter] = useState("");
  const getAllContestApi = useCallback(async () => {
    try {
      await dispatch(
        getAllContest({ page: page + 1, limit: pageLimit, filter, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, filter, searchData]);

  useEffect(() => {
    getAllContestApi();
  }, [getAllContestApi]);
  const filterOptions = [
    { value: "", label: "All" },
    { value: "upcoming", label: "Upcoming" },
    { value: "ongoing", label: "Ongoing" },
    { value: "completed", label: "Completed" },
  ];

  const columns = [
    {
      label: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { label: "Name", key: "name", render: (_, row) => row?.name || "-" },
    {
      label: "Contest Type",
      key: "contest-type",
      render: (_, row) =>
        row?.["contest-type"]?.name ? row?.["contest-type"]?.name : "-",
    },
    {
      label: "F.S/T.S",
      key: "f.s/t.s",
      render: (_, row) =>
        row?.filledSpots || row?.totalSpots
          ? row?.filledSpots + "/" + row?.totalSpots
          : "-",
    },
    {
      label: "Start Date",
      key: "start-date",
      render: (_, row) =>
        row.startDate
          ? moment(convertUtcToIst(row.startDate)).format("YYYY-MM-DD hh:mm A")
          : "-",
    },
    {
      label: "End Date",
      key: "end-date",
      render: (_, row) =>
        row.endDate
          ? moment(convertUtcToIst(row.endDate)).format("YYYY-MM-DD hh:mm A")
          : "-",
    },
    {
      label: "Status",
      key: "status",
      render: (_, row) =>
        filterOptions ? (
          <li
            className={`py-1 px-2 max-w-[7rem] mx-auto flex justify-center text-sm leading-5 font-semibold rounded-full ${
              row?.status === "completed"
                ? "bg-red-100 text-red-500"
                : row?.status === "ongoing"
                ? "bg-green-100 text-green-500"
                : row?.status === "upcoming"
                ? "bg-blue-100 text-blue-500"
                : ""
            }`}
          >
            {row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}
          </li>
        ) : (
          row?.status
        ),
    },
  ];
  const exportToPDF = () => {
    const headersConfig = [
      {
        label: "S/N",
        key: "index",
        render: (_, __, index) => page * pageLimit + index + 1,
      },
      { label: "Name", key: "name", render: (_, row) => row?.name || "-" },
      {
        label: "Contest Type",
        key: "contest-type",
        render: (_, row) =>
          row?.["contest-type"]?.name ? row?.["contest-type"]?.name : "-",
      },
      {
        label: "F.S/T.S",
        key: "f.s/t.s",
        render: (_, row) =>
          row?.filledSpots || row?.totalSpots
            ? row?.filledSpots + "/" + row?.totalSpots
            : "-",
      },
      {
        label: "Start Date",
        key: "start-date",
        render: (_, row) =>
          row.startDate
            ? moment(convertUtcToIst(row.startDate)).format(
                "YYYY-MM-DD hh:mm A"
              )
            : "-",
      },
      {
        label: "End Date",
        key: "end-date",
        render: (_, row) =>
          row.endDate
            ? moment(convertUtcToIst(row.endDate)).format("YYYY-MM-DD hh:mm A")
            : "-",
      },
      {
        label: "Status",
        key: "status",
        render: (_, row) => row?.status,
      },
    ];
    const data = getContestData?.contest_data || [];
    exportToTablePDF({
      tableName: "Contest Data",
      data,
      headersConfig,
      pdfName: "contest_data.pdf",
    });
  };
  return (
    <>
      <Table
        title="Contest"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        columns={columns}
        data={getContestData?.contest_data}
        pageCount={getContestData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        filterOptions={filterOptions}
        selectedFilter={filter}
        onFilterChange={(e) => setFilter(e ? e.value : "")}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />
    </>
  );
};

export default Contest;
